export default __webpack_public_path__ + "static/product-owner-54bf205a8582e8f3565c9c343a711748.svg";